import PrivateRoute from 'utils/privateRoute';
import PipelineRunStatusDashboard from 'components/PipelineRunStatus';
import DataAssets from 'components/PipelineRunStatus/DataAssets';
import MetadataUpdatesPage from 'components/PipelineRunStatus/MetadataUpdatesPage';

const PipelineRunStatusRoutes = [
  {
    key: 'pipeline_run_status_dashboard',
    route: '/dataOps/integratedJobMonitoring',
    component: (
      <PrivateRoute
        Component={PipelineRunStatusDashboard}
      />
    ),
  },
  {
    key: 'data_assets_page',
    route: '/dataOps/integratedJobMonitoring/dataAssets',
    component: (
      <PrivateRoute
        Component={DataAssets}
      />
    ),
  },
  {
    key: 'metadata_updates_page',
    route: '/dataOps/integratedJobMonitoring/metadataUpdates',
    component: (
      <PrivateRoute
        Component={MetadataUpdatesPage}
      />
    ),
  },
];

export default PipelineRunStatusRoutes;
